import { X as CloseIcon } from "@untitledui/icons";
import { Button as AriaButton, type ButtonProps as AriaButtonProps } from "react-aria-components";
import { cx } from "@/utils/cx";

const sizes = {
  xs: { root: "size-7", icon: "size-4" },
  sm: { root: "size-9", icon: "size-5" },
  md: { root: "size-10", icon: "size-5" },
  lg: { root: "size-11", icon: "size-6" },
};

const themes = {
  light:
    "text-arc-gray-600 hover:bg-arc-primary-100 hover:text-arc-primary-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-arc-primary-500",
  dark: "text-arc-base-white/70 hover:text-arc-base-white hover:bg-arc-base-black/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-arc-primary-300",
};

interface CloseButtonProps extends AriaButtonProps {
  theme?: "light" | "dark";
  size?: "xs" | "sm" | "md" | "lg";
  label?: string;
}

export const CloseButton = ({
  label,
  className,
  size = "sm",
  theme = "light",
  ...otherProps
}: CloseButtonProps) => {
  return (
    <AriaButton
      {...otherProps}
      aria-label={label || "Close"}
      className={(state) =>
        cx(
          "flex cursor-pointer items-center justify-center rounded-lg p-2 transition duration-100 ease-linear focus:outline-hidden",
          sizes[size].root,
          themes[theme],
          typeof className === "function" ? className(state) : className,
        )
      }
    >
      <CloseIcon
        aria-hidden="true"
        className={cx("transition-inherit-all shrink-0", sizes[size].icon)}
      />
    </AriaButton>
  );
};
